import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { filter, forkJoin, map, of, switchMap } from "rxjs";
import { ExternalAppAccountOpenAiSdk } from "@sdks/external-app-account-open-ai.sdk";
import { ExternalAppUserOpenAiSdk } from "@sdks/external-app-user-open-ai.sdk";
import { openAiLinkActions } from "./open-ai-link.actions";

@Injectable()
export class OpenAiLinkEffects {

    public init$ = createEffect(() => this.actions$.pipe(
        ofType(openAiLinkActions.initialize),
        switchMap(() => forkJoin([this.openAiSdk.isLinked(), this.openAiAccountSdk.isLinked()]).pipe(
            switchMap((data) => {
                if (typeof (data[0]) === 'boolean' && data[0] === true) {
                    return of(openAiLinkActions.load({ settings: { isLinked: data[0], isAccountKey: false } }));
                }
                else if (typeof (data[1]) === 'boolean' && data[1] === true) {
                    return of(openAiLinkActions.load({ settings: { isLinked: data[1], isAccountKey: true } }));
                }
                else if (typeof (data[0]) === 'boolean') {
                    return of(openAiLinkActions.load({ settings: { isLinked: data[0], isAccountKey: false } }));
                }
                else {
                    return of({ type: 'noop' });
                }
            }))
        )
    ));

    public load$ = createEffect(() => this.actions$.pipe(
        ofType(openAiLinkActions.load),
        filter((props) => props.settings.isLinked),
        switchMap((props) => {
            if (!props.settings.isAccountKey)
                return this.openAiSdk.get().pipe(
                    map((data) => ({ data, props })))
            else
                return this.openAiAccountSdk.get().pipe(
                    map((data) => ({ data, props })))
        }),
        switchMap(({ data, props }) => {
            if (data) {
                return of(openAiLinkActions.loaded({
                    settings: {
                        apiKey: data.apiKey,
                        model: data.model,
                        isLinked: true,
                        isAccountKey: props.settings.isAccountKey,
                    }
                }));
            }
            else {
                return of({ type: 'noop' });
            }
        })));

    constructor(
        private actions$: Actions,
        private openAiAccountSdk: ExternalAppAccountOpenAiSdk,
        private openAiSdk: ExternalAppUserOpenAiSdk
    ) { }
}